// extracted by mini-css-extract-plugin
module.exports = {"text":"bodyCopySkins-largeOnConfined-text-2a83fdbf"};